import { Pagination } from "@mui/material";
import styled from "styled-components";

const MRPagination = styled(Pagination)``;

export default MRPagination;
